import axios from 'axios'
import store from '@state/store'

export default (routeTo, routeFrom, next) => {
  routeTo.params.layout = 'bg-screen'

  // If the user is already logged in
  if (store.getters['auth/loggedIn']) {
    const { params } = routeTo

    // Redirect to the home page instead
    next({ name: 'member-profile', params })
  } else {
    axios
      .post('/api/v2/get_dropdown')
      .then(({ data }) => {
        routeTo.params.dropdown = data

        // Continue to the register page
        next()
      })
      .catch(() => {
        next() // 500 - internal server error
      })
  }
}
